import { render } from "./CreateResults.vue?vue&type=template&id=04bd67f0"
import script from "./CreateResults.vue?vue&type=script&lang=js"
export * from "./CreateResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__